import { useQuery } from "@tanstack/react-query";
import useNotifications from "../useNotifications";
import { QueryKeys } from "../../constants/queryKeys";
import { NotificationVariant } from "../../components/dashboard/NotificationsProvider";
import locationApi from "../../api/providers/locationApi";
import { Location, LocationQuery } from "../../types/location";

type Options = {
  cacheTime?: number;
  staleTime?: number;
  refetchInterval?: number;
  enabled?: boolean;
};

const init: Location[] = [];

const useLocations = (query?: LocationQuery, options: Options = {}) => {
  const { setNotification } = useNotifications();

  const { data, isLoading, isFetching, error } = useQuery({
    queryKey: [QueryKeys.LOCATIONS, query],
    queryFn: ({ signal }) => locationApi.getLocations(query, signal),
    select: (locations) =>
      [...(locations || [])].sort((a, b) =>
        (a.name ?? "").localeCompare(b.name ?? "", undefined, {
          sensitivity: "base",
        }),
      ),
    // eslint-disable-next-line @tanstack/query/no-deprecated-options
    onError: () => {
      setNotification({
        message:
          "Unable to retrieve organization's locations. Please refresh the page and try again, or contact technical support.",
        variant: NotificationVariant.error,
      });
    },
    staleTime: 10 * 60 * 1000, // 10 minutes
    ...options,
  });

  return {
    locations: data || init,
    isLoading,
    isFetching,
    error,
  };
};

export default useLocations;
